// extracted by mini-css-extract-plugin
module.exports = {"header":"ProviderList_header__1mJbV","card":"ProviderList_card__1sI-B","content":"ProviderList_content__1F9_b","table":"ProviderList_table__2tDnA"};